import React from 'react';
import {
  Create as RaCreate,
  TextInput,
  useGetIdentity,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  required,
} from 'react-admin';
import { withPermissions } from '../../components/hoc/WithPermissions';

import { USER_ROLE } from '../../constants/statuses';

const Create = (props) => {
  const { loading: identityLoading } = useGetIdentity();
  const redirect = (basePath) => `${basePath}`;

  if (identityLoading) {
    return null;
  }

  return (
    <RaCreate {...props}>
      <SimpleForm redirect={redirect}>
        <ReferenceInput validate={required()} label="Geo group" reference="geo-group" source="geoGroup">
          <SelectInput />
        </ReferenceInput>
        <TextInput validate={required()} source="name" />
      </SimpleForm>
    </RaCreate>
  );
};
export default withPermissions(Create, null, [USER_ROLE.SUPER_ADMIN]);
